export default {
  currentLog(state) {
    return state.currentLog
  },
  currentLogRow(state) {
    if (!state.currentLog) return

    const log = state.currentLog
    return [
      {
        time: log.time,
        message: log.message,
        url: log.url,
        application: log.application,
        userId: log.userId,
        guestId: log.guestId,
      },
    ]
  },
  currentLogTrace(state) {
    return state.currentLog && state.currentLog.trace
  },
  currentLogContent(state) {
    return state.currentLog && state.currentLog.content
  },
  currentLogDate(state) {
    return state.currentLog && state.currentLog.time
  },
  unsolved(state) {
    return state.unsolved
  },
}
